import React, {
  useCallback,
  useContext,
} from "react";
import { BallotContext } from "../ballot/ballot.context";
import { IQuestionState } from "../../../domain/ballot-state";


export interface SubmitResult {
  success: boolean;
  message?: string;
  code: string;
}


export const useQuestionState = (question_id: string): [IQuestionState, (v: React.SetStateAction<IQuestionState>) => void] => {
  const { questionStates, setQuestionState } = useContext(BallotContext);
  const questionState: IQuestionState =
    questionStates[question_id] || {};

  const handleSetQuestioneState = useCallback((value: React.SetStateAction<IQuestionState>) => {
    setQuestionState(question_id, value)
  }, [setQuestionState, question_id])

  return [questionState, handleSetQuestioneState];
}